module.exports = __webpack_public_path__ + "static/img/easter.28b95b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/easter.jpg
// module id = fqkn
// module chunks = 1